<app-loader *ngIf="loaderService.loading$ | async" text="Loading..." [overlay]="true" size="medium">
</app-loader>

<router-outlet></router-outlet>
